import { useSyncExternalStore } from 'react';
import {
  getThemeChoice,
  isDarkNow,
  setThemeChoice,
  subscribeTheme,
  type ThemeChoice,
} from '../lib/theme';

/**
 * The theme as React state, shared by every component that shows or changes
 * it (the dock button, the Settings chooser). useSyncExternalStore because
 * the source of truth is localStorage plus a media query, not a provider.
 */
export function useThemeChoice(): {
  choice: ThemeChoice;
  dark: boolean;
  setChoice: (choice: ThemeChoice) => void;
} {
  const choice = useSyncExternalStore(subscribeTheme, getThemeChoice);
  const dark = useSyncExternalStore(subscribeTheme, isDarkNow);
  return { choice, dark, setChoice: setThemeChoice };
}
